export class DeliveryPackage{
      id:number;
      sender:string;
      sentOn:any;
      deliveryExpectedOn:any;
      receptionOn:any;
      sample:number;
      box:number;
      problem:number;
      comments:string;
      problemLog:string;
      missing:string;
      lab:string;
      puid:string;
      shipmentStatus:ShipmentStatus;
      shipmentId:string;
      isDeleted:boolean;
      isUploaded:boolean;
      deleteSamples:boolean;
      creationDate:any;
      lastModifiedDate:any;
}

export enum ShipmentStatus {
      ANNOUNCED,
      RECEIVED,
      UNBOXING,
      COMPLETED,
      CANCELLED
}
export interface SelectableShipmentStatus {
      name: string,
      value: ShipmentStatus;
  } 